module.exports = __webpack_public_path__ + "static/media/move-row-icon-primary.5de9c3d4.svg";